import type { SiteConfig } from './site-types';

export function renderAboutParagraph(text: string, name: string): string {
	return text.replaceAll('{name}', `<strong>${name}</strong>`);
}

export function getAboutParagraphs(site: SiteConfig): string[] {
	return site.about.paragraphs;
}
